export const STRATEGY_BLIND_TRANSFER = {
    "onSecondCallConected": function () {
        if (typeof onSecondCallConected === 'function') {
            onSecondCallConected();
        }
    },
    "onSecondCallHangUp": function (json) {
        if (typeof onSecondCallHangUp === 'function') {
            onSecondCallHangUp(json.data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyBlindTransfers.js